var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  'use strict';

  if (!String.format) {
    String.format = function (format) {
      var args = Array.prototype.slice.call(arguments, 1);
      return format.replace(/{(\d+)}/g, function (match, number) {
        return angular.isDefined(_typeof(args[number])) ? args[number] : match;
      });
    };
  }

  if (!window.PopupCenter) {
    var PopupCenter = function PopupCenter(url, title, w, h) {
      var userAgent = navigator.userAgent,
          mobile = function mobile() {
        return (/\b(iPhone|iP[ao]d)/.test(userAgent) || /\b(iP[ao]d)/.test(userAgent) || /Android/i.test(userAgent) || /Mobile/i.test(userAgent)
        );
      },
          screenX = angular.isDefined(_typeof(window.screenX)) ? window.screenX : window.screenLeft,
          screenY = angular.isDefined(_typeof(window.screenY)) ? window.screenY : window.screenTop,
          outerWidth = angular.isDefined(_typeof(window.outerWidth)) ? window.outerWidth : document.documentElement.clientWidth,
          outerHeight = angular.isDefined(_typeof(window.outerHeight)) ? window.outerHeight : document.documentElement.clientHeight - 22,
          targetWidth = mobile() ? null : w,
          targetHeight = mobile() ? null : h,
          V = screenX < 0 ? window.screen.width + screenX : screenX,
          left = parseInt(V + (outerWidth - targetWidth) / 2, 10),
          right = parseInt(screenY + (outerHeight - targetHeight) / 2.5, 10),
          features = [];
      if (targetWidth !== null) {
        features.push('width=' + targetWidth);
      }
      if (targetHeight !== null) {
        features.push('height=' + targetHeight);
      }
      features.push('left=' + left);
      features.push('top=' + right);
      features.push('scrollbars=1');

      var newWindow = window.open(url, title, features.join(','));

      if (window.focus) {
        newWindow.focus();
      }

      return newWindow;
    };

    window.PopupCenter = PopupCenter;
  }

  angular.module('cloudesire.common', ['ngSanitize', 'tmh.dynamicLocale', 'angularMoment', 'restangular', 'LocalStorageModule', 'pascalprecht.translate', 'angular-extend-promises']).config(['localStorageServiceProvider', function (localStorageServiceProvider) {
    return localStorageServiceProvider.setPrefix('cd');
  }]);
})();
(function () {
  'use strict';

  configurationService.$inject = ['commonConstants'];
  angular.module('cloudesire.common').provider('configurationService', configurationService);

  function _isEmpty(el) {
    return !(!!el && el.length > 0);
  }

  /* @ngInject */
  function configurationService(commonConstants) {
    var _this = this;

    var allConstants = _.merge(commonConstants, window.config.constants || {});
    var language = window.config.language;
    var config = window.config.default;

    this.isProduction = function () {
      return config.env !== 'dev';
    };

    var hashPrefix = !this.isProduction() ? '#!' : '';
    var controlPanelBaseUrl = '' + config.controlPanelBaseUrl + hashPrefix;
    var marketplaceToControlPanelBaseUrl = '' + (config.marketplaceToControlPanelBaseUrl || config.controlPanelBaseUrl) + hashPrefix;

    var controlPanelProductPath = config.controlPanelProductPath;
    var controlPanelRegisterAsUrl = controlPanelBaseUrl + '/register/as';
    var randomRatingLimitReviews = config.randomRatingLimitReviews;

    config.marketplaceType = (config.marketplaceType || 'REGULAR').toUpperCase();

    this.getGACode = function () {
      return config.gaCode;
    };
    this.getAdWordsObject = function () {
      return config.adWordsObject;
    };
    this.getUserVoiceTimeoutMs = function () {
      return config.userVoiceTimeoutMs;
    };
    this.getMarketplaceBaseUrl = function () {
      return '/' + hashPrefix;
    };
    this.getMarketplaceProductPath = function () {
      return config.marketplaceProductPath;
    };
    this.getMeasuringUnits = getMeasuringUnits;
    this.getMarketplaceProductUrl = getMarketplaceProductUrl;
    this.getBaseUrl = function () {
      return config.endpoint.url;
    };
    this.getVivaceBaseUrl = function () {
      return config.endpointVivace.url;
    };
    this.getAvailableLanguages = function () {
      return language.availableLanguages;
    };
    this.getLanguages = function () {
      return _isEmpty(config.languages) ? language.availableLanguages : config.languages;
    };
    this.getDefaultLanguage = getDefaultLanguage;
    this.isMarketplaceDisabled = function () {
      return config.disableMarketplace === true;
    };
    this.getCustomLoginUrl = function () {
      return config.loginUrl;
    };
    this.getFrontendBaseUrl = function () {
      return config.baseUrl;
    };
    this.getControlPanelBaseUrl = function () {
      return controlPanelBaseUrl;
    };
    this.getMarketplaceToControlPanelBaseUrl = function () {
      return marketplaceToControlPanelBaseUrl || controlPanelBaseUrl;
    };
    this.getCmwEnvironment = function () {
      return window.config.default.environment || window.config.default.cmwEnvironment;
    };
    this.getCmwEnvironmentObject = getCmwEnvironmentObject;
    this.getFeatures = function () {
      return getCmwEnvironmentObject.bind(_this)().then(function (env) {
        return env.features;
      });
    };
    this.getFrontendFeatures = function () {
      return getCmwEnvironmentObject.bind(_this)().then(function (env) {
        return env.frontendFeatures;
      });
    };
    this.getControlPanelProductUrl = function (productId, productSlug) {
      return '' + controlPanelBaseUrl + String.format(controlPanelProductPath, productId, productSlug);
    };
    this.getControlPanelRegisterAsUrl = function () {
      return controlPanelBaseUrl + '/register/as';
    };
    this.getControlPanelRegisterAsVendorUrl = function () {
      return controlPanelRegisterAsUrl;
    };
    this.getControlPanelRecoverPassword = function () {
      return marketplaceToControlPanelBaseUrl + '/forgot_password';
    };
    this.getControlPanelLoginUrl = function () {
      return marketplaceToControlPanelBaseUrl + '/login';
    };
    this.getControlPanelDashboardUrl = function () {
      return marketplaceToControlPanelBaseUrl + '/admin/dashboard';
    };
    this.getControlPanelApplicationsUrl = function () {
      return marketplaceToControlPanelBaseUrl + '/admin/applications';
    };
    this.getRandomRatingLimitReviews = function () {
      return randomRatingLimitReviews;
    };
    // **************
    // storage workaround 🤢
    //
    // `storageUrl` is not injected as other configs
    // must be set on application boot (e.g. index.html)
    // **************
    this.getSettingsJsonUrl = function () {
      return config.storageUrl;
    };
    // **************
    this.getMarketplaceApiUrl = function () {
      return config.marketplaceApiUrl;
    };
    this.getFeedbackApiUrl = function () {
      return config.feedbackApiUrl;
    };
    this.getFastwebApiUrl = function () {
      return config.fastwebApiUrl;
    };
    this.getCspIndexerUrl = function () {
      return config.cspIndexerUrl;
    };
    this.getCaptchaKey = function () {
      return config.captchaKey;
    };
    this.getStripeKey = function () {
      return config.stripeKey;
    };
    this.getChangelogUrl = function () {
      return config.changelogUrl;
    };
    this.getDocumentationParameters = function () {
      return config.documentationParameters;
    };
    this.getApiVersion = function () {
      return allConstants.apiVersion;
    };
    this.getHeadersToOverride = function () {
      return getHeadersToOverride();
    };
    this.getKongIpAddresses = function () {
      return getKongIpAddresses();
    };

    // marketplace mode
    this.getCatalogModes = getCatalogModes;
    this.getCatalogMode = function () {
      return config.catalogMode || 'standard';
    };
    this.isPriceListMode = function () {
      return config.catalogMode === 'priceList';
    };
    this.isShowcaseMode = function () {
      return config.catalogMode === 'showcase';
    };

    // reselling
    // backward compatibility
    this._oldIsChildMarketplace = function () {
      return config.reseller && config.resellerName;
    };
    this._oldIsParentMarketplace = function () {
      return config.reseller && !config.resellerName;
    };

    this.getOwnerUsername = function () {
      return config.ownerUsername || config.resellerName;
    };
    this.getConfigurationFileName = function () {
      return config.configurationFileName || config.profileName;
    };
    this.getProfileName = function () {
      return _this.getOwnerUsername() || config.profileName;
    };
    this.getResellerDomain = function () {
      return config.resellerDomain;
    };
    this.getDistributorDomain = function () {
      return config.distributorDomain;
    };
    this.isParentMarketplace = function () {
      return config.marketplaceType === 'PARENT' || _this._oldIsParentMarketplace();
    };
    this.isChildMarketplace = function () {
      return _this.isDistributorChildMarketplace() || _this.isResellerChildMarketplace() || _this._oldIsChildMarketplace();
    };
    this.isResellerChildMarketplace = function () {
      return config.marketplaceType === 'RESELLER' || _this._oldIsChildMarketplace();
    };
    this.isDistributorChildMarketplace = function () {
      return config.marketplaceType === 'DISTRIBUTOR';
    };

    this.$get = function () {
      var service = {
        isProduction: this.isProduction,
        getAvailableLanguages: this.getAvailableLanguages,
        getLanguages: this.getLanguages,
        getDefaultLanguage: this.getDefaultLanguage,
        isMarketplaceDisabled: this.isMarketplaceDisabled,
        getCustomLoginUrl: this.getCustomLoginUrl,
        config: window.config.default,
        getCmwEnvironment: this.getCmwEnvironment,
        getCmwEnvironmentObject: this.getCmwEnvironmentObject,
        getFeatures: this.getFeatures,
        getFrontendFeatures: this.getFrontendFeatures,
        getAdWordsObject: this.getAdWordsObject,
        getUserVoiceTimeoutMs: this.getUserVoiceTimeoutMs,
        getFrontendBaseUrl: this.getFrontendBaseUrl,
        getHashPrefix: this.getHashPrefix,
        getControlPanelRegisterAsUrl: this.getControlPanelRegisterAsUrl,
        getControlPanelRegisterAsVendorUrl: this.getControlPanelRegisterAsVendorUrl,
        getControlPanelRecoverPassword: this.getControlPanelRecoverPassword,
        getControlPanelProductUrl: this.getControlPanelProductUrl,
        getControlPanelLoginUrl: this.getControlPanelLoginUrl,
        getControlPanelDashboardUrl: this.getControlPanelDashboardUrl,
        getControlPanelApplicationsUrl: this.getControlPanelApplicationsUrl,
        getVivaceBaseUrl: this.getVivaceBaseUrl,
        getRandomRatingLimitReviews: this.getRandomRatingLimitReviews,
        getSettingsJsonUrl: this.getSettingsJsonUrl,
        getMarketplaceApiUrl: this.getMarketplaceApiUrl,
        getFastwebApiUrl: this.getFastwebApiUrl,
        getMarketplaceBaseUrl: this.getMarketplaceBaseUrl,
        getMarketplaceProductUrl: this.getMarketplaceProductUrl,
        getMarketplaceProductPath: this.getMarketplaceProductPath,
        getMeasuringUnits: this.getMeasuringUnits,
        getBaseUrl: this.getBaseUrl,
        getControlPanelBaseUrl: this.getControlPanelBaseUrl,
        getCatalogModes: this.getCatalogModes,
        getCatalogMode: this.getCatalogMode,
        isPriceListMode: this.isPriceListMode,
        isShowcaseMode: this.isShowcaseMode,
        getOwnerUsername: this.getOwnerUsername,
        _oldIsParentMarketplace: this._oldIsParentMarketplace,
        _oldIsChildMarketplace: this._oldIsChildMarketplace,
        getConfigurationFileName: this.getConfigurationFileName,
        getProfileName: this.getProfileName,
        isResellerChildMarketplace: this.isResellerChildMarketplace,
        isDistributorChildMarketplace: this.isDistributorChildMarketplace,
        isChildMarketplace: this.isChildMarketplace,
        isParentMarketplace: this.isParentMarketplace,
        getResellerDomain: this.getResellerDomain,
        getDistributorDomain: this.getDistributorDomain,
        getCaptchaKey: this.getCaptchaKey,
        getStripeKey: this.getStripeKey,
        getFeedbackApiUrl: this.getFeedbackApiUrl,
        getCspIndexerUrl: this.getCspIndexerUrl,
        getChangelogUrl: this.getChangelogUrl,
        getDocumentationParameters: this.getDocumentationParameters,
        getApiVersion: this.getApiVersion,
        getHeadersToOverride: this.getHeadersToOverride,
        getKongIpAddresses: this.getKongIpAddresses
      };

      return service;
    };

    function getCmwEnvironmentObject() {
      return angular.injector(['ng']).get('$http').get(window.config.default.endpoint.url + '/environment/' + this.getCmwEnvironment(), { cache: true }).then(function (res) {
        return res.data;
      });
    }

    function getDefaultLanguage() {
      var supportedLanguages = this.getLanguages();
      var defaultLanguage = supportedLanguages.length > 0 ? supportedLanguages[0] : 'en';

      try {
        var browserLanguageRegex = /(^[A-Za-z]{2})(-[A-Za-z]{2})?/;
        var browserLanguageRegexGroups = browserLanguageRegex.exec(window.navigator.language);
        if (browserLanguageRegexGroups.length >= 1) {
          var browserLanguage = browserLanguageRegexGroups[1];
          if (supportedLanguages.indexOf(browserLanguage) < 0) throw new Error("Browser language not available");
          defaultLanguage = browserLanguage;
        } else {
          throw new Error('Cannot retrieve the browser language');
        }
      } catch (e) {
        if (console && console.warn) console.warn(e);
      }

      return defaultLanguage;
    }

    function getMeasuringUnits() {
      var injector = angular.injector(['ng']);
      var $http = injector.get('$http');
      var path = ('/' + this.getControlPanelBaseUrl() + '/measuring-units.json').replace(/\/+/g, '/');
      return $http.get('' + location.origin + path).then(function (response) {
        return response.data;
      });
    }

    function getMarketplaceProductUrl(categoryId, categorySlug, productId, productSlug) {
      var baseMarketplaceProductPath = this.getMarketplaceProductPath();
      var marketplaceProductPath = String.format(baseMarketplaceProductPath, categoryId, categorySlug, productId, productSlug);
      var marketplaceBaseUrl = this.getMarketplaceBaseUrl();
      return '' + marketplaceBaseUrl + marketplaceProductPath;
    }

    function getCatalogModes() {
      return ['standard', 'priceList', 'showcase'];
    }

    function getHeadersToOverride() {
      return _.zipObject(allConstants.customHeaders, [undefined]);
    }

    function getKongIpAddresses() {
      var ipAddresses = config.kongIpAddresses;
      if (_.isEmpty(ipAddresses)) return;
      return {
        addresses: ipAddresses.join(', '),
        length: ipAddresses.length
      };
    }
  }
})();
(function () {
  'use strict';

  angular.module('cloudesire.common').constant('commonConstants', {
    customHeaders: ['CMW-As-User', 'CMW-Auth-User', 'CMW-Auth-Token', 'Social-Auth-Provider', 'Social-Auth-User', 'Social-Auth-Token'],
    userBeforeMisticaStorageKey: 'user-before-mistica'
  });
})();
(function () {
  'use strict';

  featureService.$inject = ['currentUser', 'localStorageService', 'configurationService', 'Restangular', '$q'];
  angular.module('cloudesire.common').service('featureService', featureService);

  /* @ngInject */
  function featureService(currentUser, localStorageService, configurationService, Restangular, $q) {
    this.getFeatureState = this.isEnabled = getFeatureState;
    this.getFrontendFeatureState = getFrontendFeatureState;

    function getFeatureState(name) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return $q.resolve(localStorageService.get('features')).then(function (features) {
        return features ? features : configurationService.getFeatures();
      }).tap(function (features) {
        return localStorageService.set('features', features);
      }).then(function (features) {
        return _checkState(features, name, status);
      });
    }

    function getFrontendFeatureState(name, status) {
      var featurePrefix = 'cd_frontend_features_';
      var globalFrontendFeatures = void 0;

      return $q.resolve(localStorageService.get('frontendFeatures')).then(function (features) {
        return features ? features : configurationService.getFrontendFeatures();
      }).tap(function (features) {
        return localStorageService.set('frontendFeatures', features);
      }).then(function (features) {
        return globalFrontendFeatures = features;
      }).then(function () {
        return _fetchUserMetadata(currentUser.user.id);
      }).then(function (metadata) {
        var featureOverride = {};

        _.forEach(metadata, function (value, key) {
          if (_.startsWith(key, featurePrefix) && value) {
            var cleanedKey = _.replace(key, featurePrefix, '');
            featureOverride[cleanedKey] = value;
          }
        });

        return angular.extend({}, globalFrontendFeatures, featureOverride);
      }).then(function (features) {
        return _checkState(features, name, status);
      });
    }

    function _checkState(features, name, status) {
      var featureStatus = features[name];
      if (featureStatus == null) return $q.reject();
      featureStatus = String(featureStatus).toLowerCase().split(',');
      status = String(status).toLowerCase().split(',');
      return _.isEmpty(_.intersection(featureStatus, status)) ? $q.reject() : $q.resolve(true);
    }

    function _fetchUserMetadata(userId) {
      return Restangular.all('user/' + userId).one('metadata').get().then(function (restangularizedMetadata) {
        var metadata = restangularizedMetadata.plain();
        return _.omit(metadata, 'originalElement');
      });
    }
  }
})();
(function () {
  'use strict';

  angular.module('cloudesire.common').factory('Helpers', HelpersFn);

  var AUTH_PROVIDERS = Object.freeze({
    cloudesire: 'cloudesire',
    keycloak: 'keycloak'
  });

  function HelpersFn() {
    var helpers = {};

    helpers.deepValue = function (obj, path) {
      var i = void 0,
          len = void 0;
      for (i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        if (obj && angular.isArray(obj[path[i]]) && !isNaN(path[i + 1])) {
          obj = obj[path[i]][path[i + 1]];
          i++;
        } else if (obj) {
          obj = obj[path[i]];
        }
      }

      return obj;
    };

    helpers.AUTH_PROVIDERS = AUTH_PROVIDERS;

    return helpers;
  }
})();
(function () {
  'use strict';

  i18n.$inject = ['$rootScope', '$translate', '$log', '$timeout', 'localStorageService', 'Restangular', 'currentUser', 'moment', 'configurationService', 'tmhDynamicLocale'];
  angular.module('cloudesire.common').service('i18n', i18n);

  /* @ngInject */
  function i18n($rootScope, $translate, $log, $timeout, localStorageService, Restangular, currentUser, moment, configurationService, tmhDynamicLocale) {
    var refreshUser = function refreshUser() {
      return $rootScope.$broadcast('refreshUser');
    };
    var currentLanguage = function currentLanguage() {
      return $translate.use();
    };

    this.current = currentLanguage;
    this.changeLanguage = changeLanguage;

    ///////////////////////

    function changeLanguage(language) {
      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (configurationService.getLanguages().indexOf(language) < 0) {
        language = null;
        $log.warn("Requested a language that is not supported:" + language);
      }
      language = language || $translate.preferredLanguage();
      $log.debug('Changing language to', language);
      localStorageService.set('language', language); // save language
      return $translate.use(language) // change the translations language
      .tap(function () {
        return moment.locale(language);
      }) // change the date locale
      .tap(function () {
        return tmhDynamicLocale.set(language);
      }) // change the number locale
      .tap(function () {
        return updateUserLanguage(language);
      }) // update user language field
      .tap(function () {
        return notify ? $rootScope.$broadcast('language-changed', language) : angular.noop();
      }).return(language);
    }

    function updateUserLanguage(language) {
      var misticaUser = localStorageService.get('mistica-user');
      if (!currentUser.user || misticaUser) return; // don't update mistica users' language

      Restangular.one(currentUser.user.self).patch({ language: language }).then(refreshUser);
    }
  }
})();
(function () {
  'use strict';

  keycloakService.$inject = ['$window', '$q', 'i18n', 'localStorageService'];
  angular.module('cloudesire.common').factory('keycloakService', keycloakService);

  /* @ngInject */
  function keycloakService($window, $q, i18n, localStorageService) {
    return {
      init: init,
      login: login,
      addListener: addListener,
      createLoginUrl: createLoginUrl,
      logout: logout,
      clearToken: clearToken,
      isAuthenticated: isAuthenticated,
      getSubject: getSubject,
      getToken: getToken,
      getProfile: getProfile,
      refreshToken: refreshToken,
      isExpired: isExpired
    };

    function init(checkSSO) {
      if (!$window.Keycloak) throw new Error('Keycloak library is not loaded');
      $window.keycloak = new Keycloak('/keycloak.json');

      var token = localStorageService.get('kc-token');
      var refreshToken = localStorageService.get('kc-refresh-token');
      var idToken = localStorageService.get('kc-id-token');

      return $window.keycloak.init({
        checkLoginIframe: false,
        responseMode: 'query',
        flow: 'standard',
        onLoad: checkSSO ? 'check-sso' : null,
        promiseType: 'native',
        token: token,
        refreshToken: refreshToken,
        idToken: idToken
      });
    }

    function login(locale, redirectUri) {
      checkKeycloak();
      localStorageService.set('token-provider', 'keycloak');
      return $window.keycloak.login({
        locale: locale,
        redirectUri: redirectUri
      });
    }

    function addListener(successFn, errorFn) {
      checkKeycloak();

      $window.ssoLogin = function (subject, token, refreshToken, idToken, timeSkew) {
        $window.ssoPopup.close();
        $window.keycloak.init({
          token: token,
          refreshToken: refreshToken,
          idToken: idToken,
          timeSkew: timeSkew,
          checkLoginIframe: false,
          promiseType: 'native'
        }).then(function (authenticated) {
          if (authenticated) successFn(subject, token);else errorFn();
        }).catch(errorFn);
      };
    }

    function createLoginUrl(locale, redirectUri) {
      checkKeycloak();
      return $window.keycloak.createLoginUrl({ locale: locale, redirectUri: redirectUri });
    }

    function clearToken() {
      checkKeycloak();
      return $window.keycloak.clearToken();
    }

    function logout(redirectUri) {
      checkKeycloak();
      return $window.keycloak.logout({
        redirectUri: redirectUri
      });
    }

    function isAuthenticated() {
      checkKeycloak();
      var authenticated = $window.keycloak.authenticated;

      if (authenticated) {
        localStorageService.set('kc-token', keycloak.token);
        localStorageService.set('kc-refresh-token', keycloak.refreshToken);
        localStorageService.set('kc-id-token', keycloak.idToken);
      }

      return authenticated;
    }

    function getSubject() {
      checkKeycloak();
      return $window.keycloak.subject;
    }

    function getToken() {
      checkKeycloak();
      return $window.keycloak.token;
    }

    function getProfile() {
      checkKeycloak();

      return $window.keycloak.loadUserInfo();
    }

    function refreshToken() {
      checkKeycloak();
      var defer = $q.defer();

      return $window.keycloak.updateToken();
    }

    function isExpired() {
      checkKeycloak();
      return $window.keycloak.isTokenExpired();
    }

    function checkKeycloak() {
      if (!$window.keycloak) throw new Error('Keycloak is not initialized');
    }
  }
})();
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  'use strict';

  notifyService.$inject = ['$window', '$q', '$injector', '$translate', '$rootScope', '$sce'];
  angular.module('cloudesire.common').service('notify', notifyService);

  /* @ngInject */
  function notifyService($window, $q, $injector, $translate, $rootScope, $sce) {
    var toastr = $window.toastr;
    this.messages = [];
    function updateOptions() {
      toastr.options = {
        'positionClass': 'toast-bottom-right',
        'progressBar': true,
        'newestOnTop': true,
        'showDuration': '300',
        'hideDuration': '300'
      };
    }

    updateOptions();

    this.info = function (message, opts) {
      updateOptions();
      opts = opts || {};
      toastr.options.closeButton = true;
      toastr.options.timeOut = 20000;
      toastr.options.extendedTimeOut = 10000;
      _.extend(toastr.options, opts);
      var $compile = $injector.get('$compile');
      toastr.info($compile('<div>' + message + '</div>')($rootScope.$new()));
    };

    this.success = function (message) {
      updateOptions();
      toastr.options.closeButton = false;
      toastr.options.timeOut = 5000;
      var res = toastr.success(message);
      return $q.resolve(res);
    };

    function prepareNotify(message, type) {
      updateOptions();
      toastr.options.closeButton = true;
      toastr.options.timeOut = 30000;
      toastr.options.extendedTimeOut = 30000;
      toastr.options.tapToDismiss = false;

      var $compile = $injector.get('$compile');
      var scope = $rootScope.$new();
      scope.message = $sce.trustAsHtml(message);
      var reportToUservoice = $compile('<div layout="column" layout-align="start start" class="uservoice-toast">\n          <div flex style="width: 100%;">' + scope.message + '</div>\n          <md-button cd-feedback-widget\n            position="fullscreen"\n            type="ticket"\n            class="always-on report-to-uservoice ' + type + '">{{\'report-to-uservoice\'|translate}}</md-button>\n        </div>')(scope);
      return reportToUservoice;
    }

    this.error = function (message) {
      var errorNotification = prepareNotify(message, 'error');

      toastr.error(errorNotification);
    };

    this.warning = function (message) {
      var warningNotification = prepareNotify(message, 'warning');

      toastr.warning(warningNotification);
    };

    this.pushMessage = function (message, type) {
      this.messages.push({ 'message': message, 'type': type || 'success' });
    };

    this.popAllMessages = function () {
      var message = this.messages.pop();
      while (angular.isDefined(message)) {
        this[message.type](message.message);
        message = this.messages.pop();
      }
    };

    this.remove = function () {
      toastr.clear();
    };

    this.getErrorTranslation = function (error) {
      if (typeof error === 'string') return $q.reject(error);
      if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object' && (error.key || error.code)) {
        return $translate(error.code || error.key, error.context || error.extraFields).catch(function (e) {
          var missingTranslationError = new Error('Missing translation: ' + e);
          Raven.captureException(missingTranslationError, {
            tags: {
              'translation_key': error.code || error.key
            },
            extra: {
              error: error
            }
          });

          return $q.reject(error.message || error.error);
        });
      }

      throw new Error(error);
    };
  }
})();
'use strict';

angular.module('cloudesire.common').factory('platformMessagesEditService', platformMessagesEditService);

/* @ngInject */
platformMessagesEditService.$inject = ['Restangular'];
function platformMessagesEditService(Restangular) {
  var platformMessagesEditService = angular.extend(Restangular.service('notification'), {
    retrieveAll: retrieveAll
  });

  return platformMessagesEditService;

  function retrieveAll(attrs) {
    return Restangular.all('notification').getList(attrs);
  }
}
(function () {
  'use strict';

  settingsServiceFn.$inject = ['$http', '$log', '$cacheFactory', '$translate', 'i18n', 'configurationService'];
  angular.module('cloudesire.common').factory('settingsService', settingsServiceFn);

  var FALLBACK_SETTINGS = {
    skin: 'BLUE',
    title: null,
    description: 'A simple description',
    name: null,
    claim: 'Explore the marketplace',
    subtitle: '.',
    features: {},
    socials: {},
    logo: '',
    contacts: {
      address: ['Line 1 address', 'Line 2 address'],
      vat: 'IT0000000000'
    }
  };

  var SKINS = ['BLUE', 'YELLOW', 'GREEN', 'BLACK-GREEN', 'GRAY-GREEN', 'GRAY-RED', 'GRAY-ORANGE'];
  var ABSOLUTE_URL_REGEX = /^(?:[a-z]+:)?\/\//i;

  /* @ngInject */
  function settingsServiceFn($http, $log, $cacheFactory, $translate, i18n, configurationService) {
    var getProfileName = function getProfileName() {
      return configurationService.getProfileName();
    };
    var marketplaceApiUrl = configurationService.getMarketplaceApiUrl();

    $log.info('Loading ' + getProfileName() + ' profile');

    var settings = void 0;
    var settingsUrl = void 0; // tests test this variable

    return {
      getSettings: getSettings,
      getSettingsSync: getSettingsSync,
      saveSettings: saveSettings,
      saveConfiguration: saveConfiguration,
      patchConfiguration: patchConfiguration,
      createDnsRecord: createDnsRecord,
      deleteDnsRecord: deleteDnsRecord,
      invalidateCache: invalidateCache,
      getProfileName: getProfileName,
      getAvailableSkins: function getAvailableSkins() {
        return SKINS;
      },
      isTheOwner: function isTheOwner(owner) {
        var loweredOwner = owner ? owner.toLowerCase() : void 0;
        var profileName = getProfileName();
        var configurationFileName = configurationService.getConfigurationFileName();
        var loweredProfileName = profileName ? profileName.toLowerCase() : null;
        var loweredConfigurationFileName = configurationFileName ? configurationFileName.toLowerCase() : null;
        return loweredOwner === loweredProfileName || loweredOwner === loweredConfigurationFileName;
      },
      _getSettingsUrl: function _getSettingsUrl() {
        return settingsUrl;
      }, // don't delete, tests will get mad at you
      _set$http: function _set$http(s) {
        return $http = s;
      } // don't delete, tests will get mad at you
    };

    function _getSettings(language) {
      var overwriteProfileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var lastSegmentUrl = overwriteProfileName && typeof overwriteProfileName === 'string' ? overwriteProfileName : getProfileName();

      settingsUrl = '' + configurationService.getSettingsJsonUrl() + lastSegmentUrl;
      if (language) settingsUrl = settingsUrl + '.' + language;
      settingsUrl = settingsUrl + '.json' + '?tt=' + Date.now();
      return $http.get(settingsUrl, {
        cache: true,
        headers: configurationService.getHeadersToOverride(),
        params: { ignoreErrors: true }
      });
    }

    function getSettings() {
      var overwriteProfileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return $translate.onReady().then(function () {
        return _getSettings(i18n.current(), overwriteProfileName);
      }).catch(function () {
        return _getSettings(null, overwriteProfileName);
      }) // fallback to the language-agnostic configuration
      .then(function (response) {
        return settings = response.data;
      }).catch(function () {
        return settings = angular.copy(FALLBACK_SETTINGS);
      }).then(convertSettings).catch($log.error);
    }

    function convertSettings(settings) {
      settings.subtitle = '.';
      settings.banner = settings.banner || {};

      // not filled or not an absolute url
      if (!settings.logo || notAnAbsoluteUrl(settings.logo)) settings.logo = 'https://storage.googleapis.com/cd-images/your-logo-here.png';
      if (!settings.favicon) settings.favicon = 'https://storage.googleapis.com/cd-images/shopping-cart.ico';
      if (!settings.banner.logo || notAnAbsoluteUrl(settings.banner.logo)) settings.banner.logo = 'https://storage.googleapis.com/cd-images/get-on-board-icon.png';
      return settings;
    }

    function notAnAbsoluteUrl(val) {
      return !ABSOLUTE_URL_REGEX.test(val);
    }

    function getSettingsSync() {
      return settings;
    }

    function invalidateCache() {
      $cacheFactory.get('$http').removeAll();
      settings = null;
    }

    function saveSettings(settings) {
      var languageAgnostic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var overwriteProfileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var language = languageAgnostic ? '' : '/' + i18n.current();
      var newProfileName = overwriteProfileName || getProfileName();

      return $http.post(marketplaceApiUrl + '/profile/' + newProfileName + language, settings);
    }

    function _getMarketplaceTypeFromResellerMode() {
      if (configurationService.isResellerChildMarketplace()) return 'RESELLER';
      if (configurationService.isParentMarketplace()) return 'PARENT';
      return 'REGULAR';
    }

    function saveConfiguration(configuration) {
      // convert old configuration to the new one
      configuration.ownerUsername = configuration.ownerUsername || configuration.resellerName;
      configuration.marketplaceType = configuration.marketplaceType || _getMarketplaceTypeFromResellerMode();

      return $http.post(_getConfigurationFilePath(), configuration);
    }

    function patchConfiguration(patchObject) {
      return $http.patch(_getConfigurationFilePath(), patchObject);
    }

    function _getConfigurationFilePath() {
      return marketplaceApiUrl + '/configuration/' + configurationService.getConfigurationFileName();
    }

    function createDnsRecord(user) {
      var profileName = user.company.slug;
      var role = void 0;

      if (user.userRole === 'ROLE_RESELLER') role = 'RESELLER';
      if (user.userRole === 'ROLE_DISTRIBUTOR') role = 'DISTRIBUTOR';

      var params = {
        role: role
      };

      return $http.post(marketplaceApiUrl + '/dnsRecord/' + profileName, null, { params: params }).tap(function () {
        return getSettings(user.company.slug).then(function (settings) {
          settings.name = settings.name || user.company.name;
          settings.title = settings.title || user.company.name;

          return saveSettings(settings, true, user.company.slug);
        });
      }).then(function (response) {
        return response.data.domain;
      });
    }

    function deleteDnsRecord(user) {
      return $http.delete(marketplaceApiUrl + '/dnsRecord/' + user.company.slug);
    }
  }
})();
(function () {
  'use strict';

  stripeService.$inject = ['$window', 'configurationService', 'Restangular'];
  angular.module('cloudesire.common').factory('stripeService', stripeService);

  /* @ngInject */
  function stripeService($window, configurationService, Restangular) {
    var stripe = $window.Stripe(configurationService.getStripeKey());

    return {
      getStripe: getStripe,
      getPaymentClientSecretByInvoice: getPaymentClientSecretByInvoice
    };

    function getStripe() {
      return stripe;
    }

    function getPaymentClientSecretByInvoice(invoiceId) {
      return Restangular.one('invoice/' + invoiceId + '/stripePaymentClientSecret').get();
    }
  }
})();
(function () {
  'use strict';

  angular.module('cloudesire.common').factory('currentUser', currentUser);

  function currentUser() {
    return {
      isLogged: false,
      user: null,
      currency: undefined,
      token: undefined,
      isUser: function isUser() {
        return this.user && 'ROLE_USER' === this.user.userRole;
      },
      isRealVendor: function isRealVendor() {
        return this.user && 'ROLE_VENDOR' === this.user.userRole;
      },
      isAdmin: function isAdmin() {
        return this.user && 'ROLE_ADMIN' === this.user.userRole;
      },
      isSuperAdmin: function isSuperAdmin() {
        return this.user && 'ROLE_SUPERADMIN' === this.user.userRole;
      },
      isAdministrator: function isAdministrator() {
        return this.isAdmin() || this.isSuperAdmin();
      },
      isSupervisor: function isSupervisor() {
        return this.user && 'ROLE_SUPERVISOR' === this.user.userRole;
      },
      isReseller: function isReseller() {
        return this.user && 'ROLE_RESELLER' === this.user.userRole;
      },
      isDistributor: function isDistributor() {
        return this.user && 'ROLE_DISTRIBUTOR' === this.user.userRole;
      },
      isVendorOrSupervisor: function isVendorOrSupervisor() {
        return this.isRealVendor() || this.isSupervisor();
      },
      isGreaterCustomer: function isGreaterCustomer() {
        return this.isAdmin() || this.isSuperAdmin() || this.isVendorOrSupervisor() || this.isReseller() || this.isDistributor();
      },
      isGreaterDistributor: function isGreaterDistributor() {
        return this.isAdmin() || this.isSuperAdmin() || this.isSupervisor();
      },
      isVendor: function isVendor() {
        return this.isVendorOrSupervisor();
      },
      hasCompany: function hasCompany() {
        return !!(this.user && this.user.company);
      }
    };
  }
})();
(function () {
  'use strict';

  vivaceServiceFn.$inject = ['$log', '$http', 'configurationService'];
  angular.module('cloudesire.common').factory('vivaceService', vivaceServiceFn);

  /* @ngInject */
  function vivaceServiceFn($log, $http, configurationService) {
    var vivaceBaseUrl = configurationService.getVivaceBaseUrl();
    return {
      get: function get(imageUrl) {
        if (!vivaceBaseUrl) {
          return Promise.resolve();
        }

        return $http.get(vivaceBaseUrl, {
          params: {
            imgUrl: imageUrl,
            ignoreErrors: true
          },
          cache: true
        }).catch(function (err) {
          $log.debug('Vivace', err);
          return null;
        });
      }
    };
  }
})();
'use strict';

angular.module('cloudesire.common').filter('cdComputation', ['$filter', function ($filter) {
  return function (input) {
    return $filter('number')(input, 6);
  };
}]);
'use strict';

angular.module('cloudesire.common').filter('cdDayScale', ['$filter', function ($filter) {
  return function (input) {
    return $filter('number')(input, 10);
  };
}]);
'use strict';

angular.module('cloudesire.common').filter('cdRoundUp', ['$filter', function ($filter) {
  return function (input, fractionSize) {
    var precision = Math.pow(10, fractionSize);
    var number = Math.ceil(input * precision) / precision;
    return $filter('number')(number, fractionSize);
  };
}]);
(function () {
  'use strict';

  angular.module('cloudesire.common').directive('cdBillingItemValueLabel', cdBillingItemValueLabel);

  function cdBillingItemValueLabel() {
    cdBillingItemValueLabelController.$inject = ['$scope'];

    return {
      restrict: 'E',
      template: '<span ng-if="required && valueType !== \'PAY_AS_YOU_GO\'"> <span ng-if="type === \'STAIRSTEP\'"> <span ng-if="!tag"> <span ng-if="end"> <strong>{{end}}</strong>&thinsp;{{unit|translate:{PLURALIZE:end}:\'messageformat\'}}&thinsp;{{ \'marketplace.product.billing-item-value.of\'|translate }}&thinsp;{{name}} </span> <span ng-if="!end"> <strong>{{\'marketplace.product.billing-item-value-unlimited-included\'|translate}}</strong>&thinsp;{{unit|translate:{PLURALIZE:2}:\'messageformat\'}}&thinsp;{{ \'marketplace.product.billing-item-value.of\'|translate }}&thinsp;{{name}} </span> </span> <span ng-if="tag"> {{name}} {{tag}} </span> </span> <span ng-if="type !== \'STAIRSTEP\'"> <strong>{{start}}</strong>&thinsp;{{unit|translate:{PLURALIZE:start}:\'messageformat\'}}&thinsp;{{ \'marketplace.product.billing-item-value.of\'|translate }}&thinsp;{{name}} </span> </span> <span ng-if="valueType === \'PAY_AS_YOU_GO\'"> <span ng-if="type === \'STAIRSTEP\'"> <span ng-if="!tag"> <span ng-if="end" class="pay-as-you-go-description"> <cd-currency></cd-currency> {{price | cdComputation}} per {{end}} {{unit|translate:{PLURALIZE:end}:\'messageformat\'}} {{\'marketplace.pay-as-you-go.billing-period\'|translate:{PLURALIZE:1}:\'messageformat\'}} </span> <span ng-if="!end" class="pay-as-you-go-description"> <cd-currency></cd-currency> {{price | cdComputation}} {{\'marketplace.pay-as-you-go.billing-period\'|translate:{PLURALIZE:1}:\'messageformat\'}} </span> </span> <span ng-if="tag"> {{name}} {{tag}} </span> </span> <span ng-if="type !== \'STAIRSTEP\'" class="pay-as-you-go-description"> <cd-currency></cd-currency> {{price | cdComputation}} per {{unit|translate:{PLURALIZE:1}:\'messageformat\'}} {{\'marketplace.pay-as-you-go.billing-period\'|translate:{PLURALIZE:1}:\'messageformat\'}} </span> </span> ',
      controller: cdBillingItemValueLabelController,
      scope: {
        billingItemValues: '='
      }
    };

    /* @ngInject */
    function cdBillingItemValueLabelController($scope) {
      if ($scope.billingItemValues) {
        var firstBillingItemValue = $scope.billingItemValues[0];
        $scope.end = $scope.billingItemValues[$scope.billingItemValues.length - 1].end;
        $scope.start = firstBillingItemValue.start;
        $scope.price = firstBillingItemValue.price;
        $scope.tag = firstBillingItemValue.tag;
        $scope.unit = firstBillingItemValue.item.unit;
        $scope.type = firstBillingItemValue.item.type;
        $scope.name = firstBillingItemValue.item.name;
        $scope.required = firstBillingItemValue.item.required;
        $scope.valueType = firstBillingItemValue.item.valueType;
        if ($scope.required) {
          $scope.end = firstBillingItemValue.end;
        }
        if (!$scope.required) {
          $scope.start = $scope.start !== $scope.end && $scope.end > 0 ? undefined : $scope.start;
        }
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('cloudesire.common').directive('cdCloudPricing', cdCloudPricing);

  function cdCloudPricing() {
    return {
      restrict: 'E',
      template: '<div layout="column" flex="100"> <div layout="row" flex class="cloud-pricing-head"> <span class="cloud-pricing-left" flex> {{\'cd-cloud-pricing.component\'|translate}} </span> <span class="cloud-pricing-right" flex> {{\'cd-cloud-pricing.hour-pricing\'|translate}} </span> <span class="cloud-pricing-right" flex> {{\'cd-cloud-pricing.month-pricing\'|translate}} </span> </div> <div layout="row" flex ng-repeat="line in estimateMonthly.lines | filter:{type: \'VIRTUALMACHINE\'}" ng-if="line.price.price"> <span class="cloud-pricing-values cloud-pricing-left" flex layout="row" layout-align="start center"> {{\'cd-cloud-pricing.virtual-machine\'|translate}} </span> <span ng-repeat="line in estimateHourly.lines | filter:{type: \'VIRTUALMACHINE\'}" class="cloud-pricing-values cloud-pricing-right" flex layout="row" layout-align="end center"> <span layout="row" layout-align="end center"> <span> {{ line.price.price || 0 | cdRoundUp:2 }} <small>&thinsp;<currency symbol>/{{\'cd-cloud-pricing.hour\'|translate}}</small> </span> <span layout-align="end center"> <a class="pointer cd-tooltip" layout="row" layout-align="center center" tooltips tooltip-side="right" tooltip-template="{{ line.price.price || 0 | cdComputation }}"> <span>i</span> </a> </span> </span> </span> <span ng-repeat="line in estimateMonthly.lines | filter:{type: \'VIRTUALMACHINE\'}" class="cloud-pricing-values cloud-pricing-right" flex layout="row" layout-align="end center"> <span layout="row" layout-align="end center"> <span> {{ line.price.price || 0 | cdRoundUp:2 }} <small>&thinsp;<currency symbol>/{{\'cd-cloud-pricing.month\'|translate}}</small> </span> <span layout-align="end center"> <a class="pointer cd-tooltip" layout="row" layout-align="center center" tooltips tooltip-side="right" tooltip-template="{{ line.price.price || 0 | cdComputation }}"> <span>i</span> </a> </span> </span> </span> </div> <div layout="row" flex ng-repeat="line in estimateMonthly.lines | filter:{type: \'DISKSPACE\'}" ng-if="line.price.price"> <span class="cloud-pricing-values cloud-pricing-left" flex layout="row" layout-align="start center"> {{\'cd-cloud-pricing.diskspace\'|translate}}&thinsp;({{line.unit}}) </span> <span ng-repeat="line in estimateHourly.lines | filter:{type: \'DISKSPACE\'}" class="cloud-pricing-values cloud-pricing-right" flex layout="row" layout-align="end center"> <span layout="row" layout-align="end center"> <span> {{ line.price.price || 0 | cdRoundUp:2 }} <small>&thinsp;<currency symbol>/{{\'cd-cloud-pricing.hour\'|translate}}</small> </span> <span layout-align="end center"> <a class="pointer cd-tooltip" layout="row" layout-align="center center" tooltips tooltip-side="right" tooltip-template="{{ line.price.price || 0 | cdComputation }}"> <span>i</span> </a> </span> </span> </span> <span ng-repeat="line in estimateMonthly.lines | filter:{type: \'DISKSPACE\'}" title="{{ line.price.price || 0 | cdComputation }}" class="cloud-pricing-values cloud-pricing-right" flex layout="row" layout-align="end center"> <span layout="row" layout-align="end center"> <span> {{ line.price.price || 0 | cdRoundUp:2 }} <small>&thinsp;<currency symbol>/{{\'cd-cloud-pricing.month\'|translate}}</small> </span> <span layout-align="end center"> <a class="pointer cd-tooltip" layout="row" layout-align="center center" tooltips tooltip-side="right" tooltip-template="{{ line.price.price || 0 | cdComputation }}"> <span>i</span> </a> </span> </span> </span> </div> </div> ',
      scope: {
        estimateMonthly: '=',
        estimateHourly: '='
      }
    };
  }
})();
(function () {
  'use strict';

  cdCookieConsentFn.$inject = ['$window', '$translate', '$timeout'];
  angular.module('cloudesire.common').directive('cdCookieConsent', cdCookieConsentFn);

  /* @ngInject */
  function cdCookieConsentFn($window, $translate, $timeout) {
    cdCookieConsentLink.$inject = ['scope'];

    var directive = {
      restrict: 'E',
      link: cdCookieConsentLink,
      scope: {
        href: '=',
        position: '@'
      }
    };

    return directive;

    /* @ngInject */
    function cdCookieConsentLink(scope) {
      return $translate(['cd-cookie-content.message', 'cd-cookie-content.dismiss', 'cd-cookie-content.link']).then(function (messages) {
        return $timeout(showCookieBar, 500, true, messages, scope.href, scope.position);
      });
    }

    function showCookieBar(messages) {
      var href = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#";
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "bottom-left";

      var message = messages['cd-cookie-content.message'];
      var dismiss = messages['cd-cookie-content.dismiss'];
      var link = messages['cd-cookie-content.link'];

      var nosnippetSpan = $window.document.querySelectorAll('span[data-nosnippet]');
      var cookieConsentOptions = {
        palette: {
          popup: {
            background: '#252e39'
          },
          button: {
            background: '#14a7d0'
          }
        },
        theme: 'edgeless',
        position: position,
        static: true,
        content: {
          message: message,
          dismiss: dismiss,
          link: link,
          href: href
        }
      };

      if (nosnippetSpan.length > 0) cookieConsentOptions.container = nosnippetSpan[0];

      $window.cookieconsent.initialise(cookieConsentOptions);
    }
  }
})();
(function () {
  'use strict';

  currencyDirective.$inject = ['configurationService', 'localStorageService'];
  var SYMBOLS = {
    'EUR': '&#8364;',
    'USD': '&#36;',
    'SAR': 'SR'
  };

  angular.module('cloudesire.common').directive('currency', currencyDirective).directive('cdCurrency', currencyDirective);

  /* @ngInject */
  function currencyDirective(configurationService, localStorageService) {
    return {
      scope: {},
      restrict: 'E',
      replace: true,
      template: '<span ng-bind-html="::currency" class="marketplace-currency"></span>',
      link: function link(scope, el, attrs) {
        var useSymbol = 'symbol' in attrs;

        retrieveCurrency().then(function (currency) {
          if (useSymbol) {
            currency = SYMBOLS[currency] ? SYMBOLS[currency] : currency;
          }
          scope.currency = currency;
        });

        function retrieveCurrency() {
          var currency = localStorageService.get('currency');
          if (currency) {
            return Promise.resolve(currency);
          }
          return configurationService.getCmwEnvironmentObject().then(function (environment) {
            currency = environment.configuration.currency.toUpperCase();
            localStorageService.set('currency', currency);
            return currency;
          });
        }
      }
    };
  }
})();
(function () {
  'use strict';

  featureDirective.$inject = ['featureService', '$log'];
  angular.module('cloudesire.common').directive('feature', featureDirective).directive('cdFeature', featureDirective);

  function featureDirective(featureService, $log) {
    return {
      restrict: 'A',
      scope: {
        cdFeatureIgnore: '='
      },
      link: function link($scope, el, attrs) {
        var feature = attrs.cdFeature || attrs.feature;
        // can be bool or a string (ex. ENABLED, DISABLED, PER_PLAN, ...) or array (ex. ['BOTH', 'ONLY'])
        var featureStatus = attrs.cdFeatureStatus || attrs.featureStatus;

        if ($scope.cdFeatureIgnore) {
          $log.debug('Ignoring feature', feature, featureStatus);
          return;
        }

        featureService.getFeatureState(feature, featureStatus).then(function () {
          return $log.debug('Enabled feature', feature, featureStatus);
        }).catch(function () {
          el.remove();
          $log.debug('Disabled feature', feature, featureStatus);
        });
      }
    };
  }
})();
(function () {
  'use strict';

  cdFeedbackWidget.$inject = ['currentUser', 'configurationService', 'featureService', 'i18n', 'localStorageService', 'commonConstants', '$translate', '$window', '$log', '$timeout', '$q'];
  angular.module('cloudesire.common').directive('cdFeedbackWidget', cdFeedbackWidget);

  /* @ngInject */
  function cdFeedbackWidget(currentUser, configurationService, featureService, i18n, localStorageService, commonConstants, $translate, $window, $log, $timeout, $q) {
    var directive = {
      scope: {
        position: '@',
        type: '@',
        noCategories: '@',
        subject: '='
      },
      restrict: 'A',
      link: linkFn
    };
    return directive;

    function linkFn(scope, el, attrs) {
      var element = angular.element(el)[0];
      var root = void 0;

      var isEmailType = scope.type && scope.type.substring(0, 5) === 'email';
      var featureServicePromise = isEmailType ? $q.resolve() : featureService.isEnabled('uservoice');

      featureServicePromise.then(function () {
        loadFeedbackWidget();
        var unlisten = scope.$on('language-changed', reload);
        scope.$on('$destroy', unlisten);
      }).catch(function (e) {
        el.remove();
        $log.debug('uservoice not enabled');
      });

      //////////////////////////////////

      function loadFeedbackWidget() {
        if (!$window.feedbackWidget) return $log.error('Cannot load feedback widget');

        var language = i18n.current();
        var feedbackApiUrl = configurationService.getFeedbackApiUrl();
        var user = currentUser.user;

        var misticaUser = localStorageService.get('mistica-user');
        if (misticaUser) user = localStorageService.get(commonConstants.userBeforeMisticaStorageKey) || user;

        var props = {
          position: scope.position,
          type: scope.type,
          subject: scope.subject,
          language: language,
          feedbackEndpoint: feedbackApiUrl + '/' + (scope.type || 'ticket'),
          tags: [$window.config.default.env],
          externalUserId: user ? user.externalId : null,
          categories: scope.noCategories ? null : {
            TECH_SUPPORT: $translate.instant('cd-feedback-widget.cat.tech-support'),
            BILLING_SUPPORT: $translate.instant('cd-feedback-widget.cat.billing-support')
          }
        };

        if (user) props.user = {
          name: user.name,
          email: user.email
        };

        return $timeout(function () {
          return root = $window.feedbackWidget.default(element, props);
        });
      }

      function reload() {
        preact.render('', element, root);
        loadFeedbackWidget();
      }
    }
  }
})();
(function () {
  'use strict';

  cdFrontendFeature.$inject = ['featureService', '$log'];
  angular.module('cloudesire.common').directive('cdFrontendFeature', cdFrontendFeature);

  function cdFrontendFeature(featureService, $log) {
    return {
      restrict: 'A',
      link: function link($scope, el, attrs) {
        var feature = attrs.cdFrontendFeature;
        // can be bool or a string (ex. ENABLED, DISABLED, PER_PLAN, ...) or array (ex. ['BOTH', 'ONLY'])
        var featureStatus = attrs.cdFrontendFeatureStatus;

        featureService.getFrontendFeatureState(feature, featureStatus).then(function () {
          return $log.debug('Enabled frontend feature', feature, featureStatus);
        }).catch(function () {
          el.remove();
          $log.debug('Disabled frontend feature', feature, featureStatus);
        });
      }
    };
  }
})();
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
  'use strict';

  angular.module('cloudesire.common').directive('cdSshKeyGenerator', cdSshKeyGenerator);

  function cdSshKeyGenerator() {
    cdSshKeyGeneratorController.$inject = ['$scope', '$window'];

    return {
      restrict: 'E',
      template: '<div id="ssh-key-generator-container" class="form-group" flex="100"> <p class="no-margin-top">{{\'cd-ssh-key.description\'|translate}}</p> <label for="sshPublicKey"></label> <textarea id="sshPublicKey" required name="sshPublicKey" rows="4" ng-model="cdUser.publicKey" spellcheck="false" placeholder="{{\'cd-ssh-key.public-key-placeholder\'|translate}}"></textarea> <label class="no-margin-top center">{{\'cd-ssh-key.or\'|translate}}</label> <md-button ng-click="generateKeyPair()" class="black-button">{{\'cd-ssh-key.generate-now\'|translate}}</md-button> <label ng-if="!privateKey"></label> <p ng-if="privateKey"><a class="pointer" ng-click="downloadFile(privateKey, \'cd_private_rsa\')">{{\'cd-ssh-key.click-here\'|translate}}</a> {{\'cd-ssh-key.to-download\'|translate}}</p> </div> ',
      controller: cdSshKeyGeneratorController,
      scope: {
        cdUser: '='
      }
    };

    /* @ngInject */
    function cdSshKeyGeneratorController($scope, $window) {
      $scope.generateKeyPair = generateKeyPair;
      $scope.downloadFile = downloadFile;

      function generateKeyPair() {
        $window.keygen.generateKeyPair(void 0, void 0, $scope.cdUser.email).then(function (keypair) {
          var _keypair = _slicedToArray(keypair, 2),
              privateKey = _keypair[0],
              publicKey = _keypair[1];

          $scope.cdUser.publicKey = publicKey;
          $scope.privateKey = privateKey;
          $scope.$digest();

          return privateKey;
        }).then(function (privateKey) {
          return downloadFile(privateKey, 'cd_private_rsa');
        });
      }

      function downloadFile(content, name) {
        var key = content;
        var a = $window.document.createElement('a');

        var bytes = new Uint8Array(key.length);
        for (var i = 0; i < key.length; i++) {
          bytes[i] = key.charCodeAt(i);
        }

        var blob = new Blob([bytes], { 'type': '' });

        $window.URL = $window.URL || $window.webkitURL;
        a.href = $window.URL.createObjectURL(blob);
        a.download = name;
        a.target = '_blank';
        $window.document.body.appendChild(a);
        a.click();
      }
    }
  }
})();
(function () {
  'use strict';

  cdStateSelectFn.$inject = ['Restangular'];
  var statesByCountry = {
    'US': 'AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH ' + 'OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY',
    'IT': 'AG AL AN AO AP AQ AR AT AV BA BG BI BL BN BO BR BS BT BZ CA CB CE CH CL CN CO CR CS CT CZ EN FC FE FG FI ' + 'FM FR GE GO GR IM IS KR LC LE LI LO LT LU MB MC ME MI MN MO MS MT NA NO NU OR PA PC PD PE PG PI PN PO PR ' + 'PT PU PV PZ RA RC RE RG RI RN RO RM SA SI SO SP SR SS SV TA TE TN TO TP TR TS TV UD VA VB VC VE VI VR VT VV'
  };

  angular.module('cloudesire.common').directive('cdStateSelect', cdStateSelectFn);

  /* @ngInject */
  function cdStateSelectFn(Restangular) {
    return {
      restrict: 'E',
      link: stateSelectLink,
      scope: {
        'state': '=state',
        'mandatory': '=mandatory'
      },
      template: '<div class="form-group state-select-element"> <label for="country">{{\'cd-user-information.state\'|translate}}</label> <div ng-show="states" class="cd-select-wrapper"> <select ng-required="required" ng-model="state" autocomplete="billing address-level1" ng-options="state.abbrev as state.abbrev for state in states" class="form-control"></select> <fa name="angle-down" class="material-icons"> </div> <input ng-required="required" cd-uppercase ng-hide="states" autocomplete="billing address-level1" ng-model="state" class="full-width form-control" name="state" maxlength="2"> </div> '
    };

    function stateSelectLink(scope, el, attrs) {
      var countriesMandatoryState = void 0;

      scope.required = false;
      scope.state = scope.state ? scope.state.toUpperCase() : scope.state;

      toggleElement(scope.mandatory, el);

      var deobserve = attrs.$observe('country', function (country) {
        if (!country) return;

        if (!countriesMandatoryState) {
          retrieveMandatoryStatesCountries().then(function (states) {
            return countriesMandatoryState = states;
          }).then(function () {
            return countryChanged(country);
          });
        } else {
          countryChanged(country);
        }
      });

      function countryChanged(country) {
        scope.mandatory = countriesMandatoryState.indexOf(country) >= 0;
        scope.required = angular.copy(scope.mandatory);

        toggleElement(scope.mandatory, el);

        var states = statesByCountry[country];

        if (states) {
          scope.states = states.split(' ').map(function (state) {
            return { abbrev: state };
          });
        } else {
          scope.states = void 0;
        }
      }

      scope.$on('$destroy', deobserve);
    }

    function toggleElement(mandatory, el) {
      if (mandatory) el.show();else el.hide();
    }

    function retrieveMandatoryStatesCountries() {
      return Restangular.all('enum/StateRequired').getList().then(function (result) {
        return JSON.parse(JSON.stringify(result.originalElement));
      });
    }
  }
})();
(function () {
  'use strict';

  var baseElementsOptions = {
    fonts: [{
      cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat'
    }]
  };

  var baseCardOptions = {
    style: {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: 'Montserrat',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }
  };

  angular.module('cloudesire.common').directive('cdStripeCard', cdStripeCard);

  function cdStripeCard() {
    controllerFn.$inject = ['i18n', 'stripeService'];

    var directive = {
      restrict: 'E',
      template: '<form id="stripe-card-form" ng-submit="vm.submitCard()"> <div class="form-group"> <label for="card-element"> {{\'cd-stripe-payment.credit-or-debit-card\'|translate}} </label> <div id="card-element"></div> <div id="card-errors" class="error" role="alert"></div> </div> </form>',
      controllerAs: 'vm',
      link: linkFn,
      controller: controllerFn,
      scope: {
        postalCode: '=',
        card: '=',
        focusOnReady: '=?'
      }
    };

    /* @ngInject */
    function controllerFn(i18n, stripeService) {
      var vm = this;
      vm.locale = i18n.current();
      vm.stripe = stripeService.getStripe();
    }

    function linkFn(scope, element, attrs, vm) {
      var elementsOptions = angular.copy(baseElementsOptions);
      var cardOptions = angular.copy(baseCardOptions);

      elementsOptions.locale = vm.locale;
      cardOptions.value = { postalCode: scope.postalCode };

      var elements = vm.stripe.elements(elementsOptions);
      var card = elements.create('card', cardOptions);

      scope.card = card;

      card.on('ready', function () {
        scope.focusOnReady = angular.isDefined(scope.focusOnReady) ? scope.focusOnReady : true;
        if (scope.focusOnReady) card.focus();
      });
      card.on('change', function (what) {
        if (what.error === void 0 && what.complete) {
          scope.$emit('payment-valid', 'card');
        } else {
          scope.$emit('payment-not-valid', 'card');
        }
      });
      card.mount('#card-element');
    }

    return directive;
  }
})();
(function () {
  'use strict';

  var baseElementsOptions = {
    fonts: [{
      cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat'
    }]
  };

  var baseIbanOptions = {
    supportedCountries: ['SEPA'],
    style: {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: 'Montserrat',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }
  };

  angular.module('cloudesire.common').directive('cdStripeIban', cdStripeIban);

  function cdStripeIban() {
    controllerFn.$inject = ['i18n', 'stripeService'];

    var directive = {
      restrict: 'E',
      template: '<form id="stripe-iban-form"> <div class="form-group"> <div class="form-row"> <div id="iban-element"></div> <div id="iban-bank"></div> </div> <div id="iban-errors" class="error" role="alert"></div> </div> </form>',
      controllerAs: 'vm',
      link: linkFn,
      controller: controllerFn,
      scope: {
        iban: '='
      }
    };

    /* @ngInject */
    function controllerFn(i18n, stripeService) {
      var vm = this;
      vm.locale = i18n.current();
      vm.stripe = stripeService.getStripe();
    }

    function linkFn(scope, element, attrs, vm) {
      var elementsOptions = angular.copy(baseElementsOptions);
      var ibanOptions = angular.copy(baseIbanOptions);

      elementsOptions.locale = vm.locale;

      var elements = vm.stripe.elements(elementsOptions);
      var iban = elements.create('iban', ibanOptions);

      scope.iban = iban;

      iban.on('change', function (what) {
        if (what.error === void 0 && what.complete) {
          scope.$emit('payment-valid', 'iban');
        } else {
          scope.$emit('payment-not-valid', 'iban');
        }
      });

      iban.mount('#iban-element');
    }

    return directive;
  }
})();
(function () {
  'use strict';

  cdVibrantDirective.$inject = ['vivaceService', '$log'];
  angular.module('cloudesire.common').directive('cdVibrant', cdVibrantDirective);

  /* @ngInject */
  function cdVibrantDirective(vivaceService, $log) {
    var directive = {
      restrict: 'A',
      link: vibrantLink,
      replace: true,
      scope: {
        'cdVibrant': '@',
        'cdOneTimeBinding': '@'
      }
    };

    return directive;

    function vibrantLink(scope, element, attrs) {
      var oneTimeBinding = 'cdOneTimeBinding' in attrs;
      var unobserve = attrs.$observe('cdVibrant', function (url) {
        return getVibrantColor(url).then(function (swatches) {
          if (!swatches || !swatches.data) return;
          var Vibrant = swatches.data.Vibrant;
          var vibrantRGB = Vibrant && Vibrant.population > 0 ? 'rgb ' + Vibrant.rgb[0] + ' ' + Vibrant.rgb[1] + ' ' + Vibrant.rgb[2] : 'black';

          var vibrant = tinycolor(vibrantRGB);
          while (!vibrant.isLight()) {
            vibrant = vibrant.lighten(5);
          }var lightVibrant = vibrant.setAlpha(0.1).toRgbString();
          vibrant = vibrant.setAlpha(0.5).toRgbString();
          setColorFromTo(lightVibrant, vibrant);
        }).finally(function () {
          return oneTimeBinding ? unbind() : angular.noop();
        }).catch(function (err) {
          $log.warn('Vivace', err);
          setColorFromTo('transparent', 'transparent');
          if (getVibrantColor.cache) delete getVibrantColor.cache[url];
        });
      });

      function setColorFromTo(from, to) {
        element.css('background-color', '' + to);
        element.css('background', '-webkit-linear-gradient(left top, ' + from + ', ' + to + ')');
        element.css('background', '-o-linear-gradient(bottom right, ' + from + ', ' + to + ')');
        element.css('background', '-moz-linear-gradient(bottom right, ' + from + ', ' + to + ')');
        element.css('background', 'linear-gradient(to bottom right, ' + from + ', ' + to + ')');
      }

      function getVibrantColor(imageUrl) {
        return vivaceService.get(imageUrl);
      }

      function unbind() {
        if (unobserve) unobserve();
        unobserve = null;
      }

      scope.$on('$destroy', unbind);
    }
  }
})();
